import { NavBarBtnModel } from '../../../../models';

export const NavBarButtons: NavBarBtnModel[] = [
  {
    classes: 'btn-grey',
    text: 'BUTTON.CANCEL',
    iconName: 'close',
    disabled: false,
    actionName: 'onCloseClick',
  },
  {
    classes: 'btn-primary btn-create-category',
    text: 'BUTTON.CREATE',
    iconName: 'plus-square',
    allowLoadingSpinner: true,
    actionName: 'onSubmit',
    disabled: false,
    dropdownClass: 'inner-blue-400 btn-drop-menu--inner-fluid icon-close-right',
    actions: [
      {
        actionTitle: 'BUTTON.CREATE',
        actionName: 'onSubmit',
        actionIcon: 'plus-square'
      },
      {
        actionTitle: 'BUTTON.CREATE_AND_CONTINUE',
        actionName: 'onSubmitAndContinue',
        actionIcon: 'plus-square'
      }
    ]
  },
];
